export default {
  getAll: (state) => state.items,
  getById: (state) => (reportId) =>
    state.items.find((_r) => _r._id === reportId),
}
